import { clean, getLetterIndex, loadModules, merge } from '../../../editor/core/highcharts-editor';
import templates from '../../../editor/core/highed.template.plugins';
import { getSeriesType } from 'shared/wizard/utils/seriesHelper.tsx';
import { cloneDeep, isArray } from 'lodash';
import { select } from 'redux-saga/effects';
import { getProjectConfig } from 'redux/selectors/projectConfig';
import assignDefaults from './../../../editor/meta/highed.meta.assign.defaults';
import chartTypes from './../../../editor/meta/highed.meta.charttype';

export function getTeam(localTeam, team) {
  return localTeam ?? team;
}

export function loadRelevantModules(projectData) {
  if (projectData.theme?.plugins?.cssModules) {
    loadModules(projectData.theme.plugins.cssModules, null, null, true);
  }

  let pluginConfig = {};
  if (projectData.settings?.plugins) {
    let keys = Object.keys(projectData.settings.plugins);
    (keys || []).forEach(function (key) {
      if (key !== 'cssModules') {
        if (templates[key]?.config) {
          pluginConfig = templates[key].config;
        }
        if (templates[key]?.modules) {
          loadModules(templates[key].modules, true);
        }
      }
    });
    if (projectData.settings.plugins.cssModules) loadModules(projectData.settings.plugins.cssModules, null, null, true);
  }
  return pluginConfig;
}

export function makeEmbedDetails(data) {
  return {
    injectCode: data.inject,
    iframeCode: data.iframe,
    iframeURL: data.iframeURL,
    shareUrl: 'https://api.everviz.com/share/' + data.uuid,
    socialLinks: 'https://api.everviz.com/share/' + data.uuid,
    uuid: data.uuid
  };
}

export function* fixSeriesMapping(params) {
  const { projectData, isMap, isGeoJSON } = params;
  const assignDataFields = projectData.settings?.dataProvider?.assignDataFields;
  const projectConfigOptions = {};

  if (projectData.settings?.dataProvider?.csv && assignDataFields) {
    const { aggregatedOptions } = yield select(getProjectConfig);

    const series = getSeriesType(aggregatedOptions);
    projectConfigOptions.seriesAssigns = series.map((type, index) => {
      let options = cloneDeep(assignDefaults);
      options = clean(merge(options, chartTypes[type]));
      let mappedValues = assignDataFields[index];
      if (mappedValues) {
        Object.keys(mappedValues).forEach((key) => {
          if (options[key]) {
            options[key].value = mappedValues[key];
            options[key].rawValue = [getLetterIndex(mappedValues[key])];
          }
        });
      }
      return options;
    });

    if (isMap && isGeoJSON) {
      projectConfigOptions.seriesAssigns = (projectConfigOptions.seriesAssigns ?? []).map((assign) => {
        if (assign?.labels?.linkedTo === 'hc-key' && projectData.options.chart.map?.hccode) {
          assign.labels.linkedTo = projectData.options.chart.map.hccode;
        }
        return assign;
      });
    }
  }

  return projectConfigOptions;
}

export const getHighchartsResponsiveConfig = (seriesTypes, chartEditorConfig, options) => {
  let wizardSmallScreenOption = {
    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 350,
            maxHeight: 300
          },

          chartOptions: {
            title: {
              text: ''
            },
            legend: {
              enabled: false
            },
            exporting: {
              enabled: false
            },
            subtitle: {
              text: ''
            },
            caption: {
              text: ''
            },
            mapNavigation: {
              enabled: false
            },
            xAxis: {
              title: {
                text: ''
              }
            },
            yAxis: {
              title: {
                text: ''
              }
            }
          }
        }
      ]
    }
  };

  if (seriesTypes.includes('treemap')) {
    // Bug in highcharts, treemap shows a blank chart if theres an x/yAxis option being set in the responsive rules.
    delete wizardSmallScreenOption.responsive.rules[0].chartOptions.yAxis;
    delete wizardSmallScreenOption.responsive.rules[0].chartOptions.xAxis;
  } else if (chartEditorConfig.isMap) {
    delete wizardSmallScreenOption.responsive.rules[0].chartOptions.legend;
  } else {
    // Check for x/yAxis arrays. If user has multiple axis, match this so we
    // dont hide the series attached to it when the chart goes small
    ['xAxis', 'yAxis'].forEach((axis) => {
      if (options?.[axis] && isArray(options[axis])) {
        const smallScreenAxisObj = cloneDeep(wizardSmallScreenOption.responsive.rules[0].chartOptions[axis]);
        wizardSmallScreenOption.responsive.rules[0].chartOptions[axis] = new Array(options[axis].length).fill(
          smallScreenAxisObj
        );
      }
    });
  }

  return wizardSmallScreenOption;
};
